import { Validator, NG_VALIDATORS, AbstractControl } from "@angular/forms";
import { Directive } from "@angular/core";

@Directive({
  selector: '[passwordValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: PasswordValidatorDirective, multi: true }]
})
export class PasswordValidatorDirective implements Validator {

  regexp: RegExp;

  constructor() {
    this.regexp = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&^\.:;,_<>-])[A-Za-z\d$@$!%*?&^\.:;,_><-].{8,}');
  }

  validate(control: AbstractControl): { [key: string]: any } | null {
    let value = control.value;
    if (!value) return { 'Errore!': { value: control.value } };

    if (this.regexp.test(value)) return null;

    return { 'Password non valida!': { value: control.value } };
  }
}
